import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.75313 15.4957L15.8406 9.88569C16.4481 9.62319 16.4481 8.76819 15.8406 8.50569L2.75313 2.89569C2.25813 2.67819 1.71062 3.04569 1.71062 3.57819L1.70312 7.03569C1.70312 7.41069 1.98062 7.73319 2.35562 7.77819L12.9531 9.19569L2.35562 10.6057C1.98062 10.6582 1.70312 10.9807 1.70312 11.3557L1.71062 14.8132C1.71062 15.3457 2.25813 15.7132 2.75313 15.4957Z",
		fill: "white"
	})
});
export default SvgSend;
